import React from 'react';
import { FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

const ReadinessPanel = ({ blockers = [] }) => {
  const isReady = blockers.length === 0;

  return (
    <div
      className="rounded-md border px-4 py-3 shadow-primeSm"
      style={{
        borderColor: isReady ? '#6EE7B7' : '#FCD34D',
        backgroundColor: isReady ? '#D1FAE5' : '#FEF3C7',
      }}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          {isReady ? <FiCheckCircle className="h-4 w-4 text-green-700" /> : <FiAlertCircle className="h-4 w-4 text-orange-700" />}
          <p className={`text-xs font-bold ${isReady ? 'text-green-700' : 'text-orange-700'}`}>
            {isReady ? 'Publish readiness: clear' : `Publish readiness: ${blockers.length} blocker`}
          </p>
        </div>
        {!isReady && (
          <div className="flex flex-col gap-1">
            {blockers.slice(0, 3).map((blocker) => (
              <p key={blocker} className="text-xs text-orange-700">
                Fix: {blocker}
              </p>
            ))}
            {blockers.length > 3 && (
              <p className="text-xs text-orange-700">+{blockers.length - 3} blocker lainnya</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReadinessPanel;
